// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2AH9i","additionalInfo":"AgreementModal_additionalInfo__SbeBr"};